import React, { useRef } from "react";
import { Modal } from "../../../../../../shared/modals/Modal";
import {
  AgreementCloseButtonWrapper,
  AgreementContentWrapper,
  AgreementHeader,
  BottomLineSeparator,
  TopLineSeparator,
} from "./styles";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../shared/button/button";
import SafeHtml from "../../../../../common/SafeHtml";

function Agreements({ isOpen = false, onToggle, htmlData = [] }) {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Modal style={{ borderRadius: "16px" }} isOpen={isOpen} toggle={onToggle}>
        <AgreementHeader>{htmlData?.[0]}</AgreementHeader>
        <TopLineSeparator />

        <AgreementContentWrapper>
          {htmlData.slice(1)?.map((item) => {
            return <SafeHtml html={item} />;
          })}
        </AgreementContentWrapper>

        <BottomLineSeparator />
        <AgreementCloseButtonWrapper>
          <Button onClick={onToggle} width={"100%"}>
            {t("i_agree")}
          </Button>
        </AgreementCloseButtonWrapper>
      </Modal>
    </React.Fragment>
  );
}

export default Agreements;
